export type StickerCollection = {
  collectionId: number;
  enname: string;
  svname: string;
  stickerCount: number;
  tags: StickerCollectionTag[];
  description: string;
  thumbnails: string[];
  updatedBy: string;
  active: boolean;
  completed: boolean;
  languages: string[];
  categories: number[];
  tagCategoryIds?: number[];
  resolvedCategoryTags?: ResolvedCategoryTag;
  incompleteStickerCount?: number;
};

export interface StickerTagCategorySelection {
  groupId: string;
  tagIds: string[];
}

export interface StickerCreateCollectionReqestParam {
  svName: string;
  enName: string;
  active: boolean;
  categories: number[];
  svTags: string[];
  enTags: string[];
  stickers?: StickerUpload[];
  languages: string[];
  visualQualitySelections?: Record<string, string[]>;
  themeSelections?: Record<string, string[]>;
}

export interface StickerUpload {
  filename: string;
  collectionId?: number;
  base64: string;
  completed: boolean;
  categories?: number[];
}

export interface StickerCreateRequest {
  filename: string;
  collectionId: number;
  base64: string;
  hidden: boolean;
  categories: number[];
  languages: string[];
}

export interface StickerUpdateParams {
  stickerId: number;
  filename?: string;
  collectionId: number;
  categories: number[];
  languages?: string[];
  swedishAltText: string;
  englishAltText: string;
  englishTags: string[];
  swedishTags: string[];
  completed?: boolean;
}

export interface CreateCollectionSubmitStatus {
  step1: boolean;
  step2: boolean;
  step3: boolean;
  step4: boolean;
  step5: boolean;
}

export type StickerNotification = {
  show: boolean;
  status: string;
  message: string;
  heading?: string;
};

export interface StickerCollectionTag {
  _id?: string;
  language: string;
  tags: string[];
}

export interface ResolvedCategoryTag {
  english: string[];
  swedish: string[];
}

export interface StickerDescObject {
  _id: string;
  language: string;
  description: string;
}

export interface Sticker {
  _id: string;
  stickerId: number;
  categories: number[];
  collectionId: number;
  collectionTags: StickerCollectionTag[];
  completed: boolean;
  createdAt: string;
  hidden: boolean;
  imageUrl: string;
  languages: string[];
  lastUpdatedAt: string;
  previewUrl: string;
  stickerDesc: StickerDescObject[];
  tags: StickerCollectionTag[];
  thumbUrl: string;
  resolvedCategoryTags?: ResolvedCategoryTag;
  tagCategoryIds?: number[];
}

export function createEmptySticker(): Sticker {
  return {
    _id: "",
    stickerId: 0,
    categories: [],
    collectionId: 0,
    collectionTags: [],
    completed: false,
    createdAt: "",
    hidden: false,
    imageUrl: "",
    languages: [],
    lastUpdatedAt: "",
    previewUrl: "",
    stickerDesc: [],
    tags: [],
    thumbUrl: "",
    tagCategoryIds: [],
  };
}
